import { Inject } from '@odinjs/odin';
import { TextAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services';

import { Endpoint } from '../../constants/endpoints';
import { ModulesRoute } from '../../constants/routes';
import BaseController from '../BaseController';

@Controller({ fragment: 'profile', component: 'layout-profile' })
export default class ProfileController extends BaseController {

  @Inject('text-last-access')
    lastAccessText: TextAPI;

  @OnMount('layout-profile')
  onInitLayout(): void {
    this.loadLastProfileAccess();
  }

  loadLastProfileAccess(): void {
    HttpService.get<string>(Endpoint.GET_PROFILE_LAST_ACCESS)
      .then(response => this.performLastAccessLabelUpdate(response.body))
      .catch(console.error);
  }

  performLastAccessLabelUpdate(profileLastAccess: string | undefined): void {
    if (!profileLastAccess) {
      return;
    }

    this.lastAccessText.setValue(`${MessageService.translate('approvals.profile.last-access')}: ${ModelService.format('date', profileLastAccess, { type: 'timestamp' })}`);
  }

  @OnClick({ target: 'link-terms-list' })
  onClickLink(): void {
    this.historyService.push(ModulesRoute.USER_TERMS_LIST);
  }
}
